// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__4CEUE","bigColWidth":"Table_bigColWidth__3vMr2","biggerColWidth":"Table_biggerColWidth__3IPAU","row":"Table_row__1VbJq","col":"Table_col__2Vtfw"};